export const getBrowserLanguage = () => {
    return navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
};
//# sourceMappingURL=get-browser-language.js.map